export default "__VITE_ASSET__BFAZjQVv__"